import { IressSkeleton, IressStack } from '@iress-oss/ids-components';
import './SkeletonLoader.css';

export function SkeletonLoader() {
  return (
    <div className="porter-skeleton" aria-label="Loading" role="status">
      <IressStack gap="xs">
        <IressSkeleton mode="text" width="31%" />
        <IressSkeleton mode="text" width="100%" />
        <IressSkeleton mode="text" width="100%" />
      </IressStack>
    </div>
  );
}
